var MenuVariant;
(function (MenuVariant) {
    MenuVariant["Hover"] = "hover";
    MenuVariant["Underline"] = "underline";
})(MenuVariant || (MenuVariant = {}));
export default MenuVariant;
